import { Box, Link, Typography, useTheme } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { Layout } from "src/components/common";
import { BoardTitle, MiddleTitle } from "../home";

interface PrivacyType {
  title: string;
  body: JSX.Element;
}

export const PrivacyPage: React.FC = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const policyClauses: PrivacyType[] = [
    {
      title: t("privacy.clauses.item1.title"),
      body: <>{t("privacy.clauses.item1.body")}</>,
    },
    {
      title: t("privacy.clauses.item2.title"),
      body: <>{t("privacy.clauses.item2.body")}</>,
    },
    {
      title: t("privacy.clauses.item3.title"),
      body: <>{t("privacy.clauses.item3.body")}</>,
    },
    {
      title: t("privacy.clauses.item4.title"),
      body: <>{t("privacy.clauses.item4.body")}</>,
    },
    {
      title: t("privacy.clauses.item5.title"),
      body: <>{t("privacy.clauses.item5.body")}</>,
    },
    {
      title: t("privacy.clauses.item6.title"),
      body: <>{t("privacy.clauses.item6.body")}</>,
    },
    {
      title: t("privacy.clauses.item7.title"),
      body: <>{t("privacy.clauses.item7.body")}</>,
    },
    {
      title: t("privacy.clauses.item8.title"),
      body: (
        <>
          {t("privacy.clauses.item8.body.item1")}
          <Link href="mailto:contact@shuluntc.com"> {t("privacy.clauses.item8.body.item2")}</Link>
          {t("privacy.clauses.item8.body.item3")}
        </>
      ),
    },
    {
      title: t("privacy.clauses.item9.title"),
      body: <>{t("privacy.clauses.item9.body")}</>,
    },
  ];

  return (
    <Layout>
      <Box
        sx={{
          width: "100%%",
          m: "0 auto",
          p: "40px 0 0",
          color: "#000",
          "@media screen and (max-width: 900px)": { padding: "30px 0 0" },
        }}
      >
        <Box
          maxWidth={1200}
          m="0 auto 50px"
          sx={{
            display: "flex",
            justifyContent: "center",
            "@media screen and (max-width: 900px)": {
              mb: "30px",
              "& p": { fontSize: 34 },
            },
          }}
        >
          <BoardTitle arrow="center" isLine>
            <Typography fontSize={50} lineHeight={1.2} letterSpacing={4} fontWeight="bold" textAlign="center" whiteSpace="normal">
              {t("privacy.title")}
            </Typography>
          </BoardTitle>
        </Box>
        <Box
          sx={{
            width: "100%",
            height: 380,
            background: `url(${require("src/assets/images/chengdu1.jpeg")}) no-repeat center center`,
            backgroundSize: "cover",
            backgroundPosition: "0% 80%",
            opacity: 0.6,
            "@media screen and (max-width: 400px)": {
              height: 300,
            },
          }}
        />
      </Box>
      <Box
        sx={{
          width: "88%",
          maxWidth: 1200,
          height: "auto",
          background: "#fff",
          margin: "0 auto -68px",
          position: "relative",
          top: -68,
          zIndex: 9,
          "@media screen and (max-width: 900px)": {
            top: -38,
            margin: "0 auto -38px",
          },
        }}
      >
        <Box
          sx={{
            width: "85%",
            m: "0 auto",
            "& >.MuiBox-root:first-of-type": {
              height: 68,
              "& p": { lineHeight: "68px" },
            },
            "& >.MuiBox-root:nth-of-type(2)": { m: "70px auto 30px", p: "40px 13% 70px" },
            "@media screen and (max-width: 900px)": {
              width: "100%",
              "& >.MuiBox-root:first-of-type": {
                width: "85%",
                m: "0 auto",
              },
              "& >.MuiBox-root:nth-of-type(2)": {
                m: "40px auto 0px",
              },
            },
          }}
        >
          <MiddleTitle text={t("privacy.top")} />
          <Box sx={{ display: "flex", flexDirection: "column", gap: "26px" }}>
            <Typography sx={{ fontSize: "14px", fontWeight: "400", lineHeight: 2.2 }}>{t("privacy.synopsis")} </Typography>
            {policyClauses.map(clause => (
              <Box key={clause.title}>
                <Typography
                  sx={{ m: "24px 0 16px", fontSize: "26px", fontWeight: "500", [theme.breakpoints.down("md")]: { fontSize: "18px" } }}
                >
                  {clause.title}
                </Typography>
                <Typography sx={{ fontSize: "14px", fontWeight: "400", lineHeight: 2.2, whiteSpace: "pre-wrap" }}>{clause.body}</Typography>
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Layout>
  );
};

export default PrivacyPage;
